import { SvgIconProps } from '@mui/material';

const ProgressionArrow = ({ height = '15', width = '14', className }: SvgIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 15"
    fill="none"
    className={className}
    aria-label="Progression Arrow"
  >
    <path
      d="M11.9997 5.38377C13.3491 6.1504 13.3491 8.09505 11.9997 8.86168L2.98795 13.9815C1.65466 14.7389 -6.81172e-08 13.776 0 12.2425L4.54856e-07 2.00294C5.22974e-07 0.469505 1.65466 -0.493489 2.98795 0.263984L11.9997 5.38377Z"
      fill="#E8E6DF"
    />
  </svg>
);

export default ProgressionArrow;
